export enum DeviceTypeEnum {
  CONSOLE = 'console',
  SMARTPHONE = 'mobile',
  TABLET = 'tablet',
  SMART_TV = 'smarttv',
  PORTABLE_DEVICE = 'wearable',
  EMBEDDED_DEVICE = 'embedded',
  DESKTOP = 'desktop',
  UNKNOWN = 'Unknown'
}
